import { getRandomNumber } from "./helperFuctions";

export const getPurchaseTrackerData = (
  price: string | number,
  gumroadId: string,
  title: string,
  mainTechnology: string[],
  primaryEmail?: any,
  secondaryEmail?: string | null
) => {
  const randomNumber = getRandomNumber();

  return {
    transaction_id: `${randomNumber}`,
    value: price,
    tax: 0,
    currency: "USD",
    primaryEmail,
    secondaryEmail,
    items: [
      {
        item_id: gumroadId,
        item_name: title,
        discount: 0,
        item_category: mainTechnology,
        price: price,
        quantity: 1,
      },
    ],
  };
};

export const getLinkViewData = (
  price: string | number,
  gumroadId: string,
  title: string,
  url: string
) => ({
  value: price,
  currency: "USD",
  items: [
    {
      item_id: gumroadId,
      item_name: title,
      item_url: url,
      price: price,
      quantity: 1,
    },
  ],
});
